<template>
  <div class="table-container">
    <vab-query-form>
      <vab-query-form-left-panel>
        <el-form ref="form" :model="queryForm" :inline="true" @submit.native.prevent>
          <el-form-item>
            <el-input v-model="queryForm.keyword" placeholder="中文品名,英文品名，税号，备案号，规格名，品牌名" style="width: 360px;" />
          </el-form-item>
         
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" native-type="submit" @click="handleQuery">
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-left-panel>

      <vab-query-form-right-panel>
         <!-- 上传商品表 -->
            <el-upload
              class="upload-demo"
              action="#"
              :http-request="exportForm3"
              :multiple="false"
              :show-file-list="false"
            >
              <el-button
                :loading="exportForm3Loading"
                size="small"
                type="primary"
                style="margin-left: 15px"
              >
                批量上传
              </el-button>
            </el-upload>
        <el-button icon="el-icon-plus" type="primary" @click="handleAdd" style="margin-left: 10px;">
          添加
        </el-button>
        <!--        <el-button icon="el-icon-delete" type="danger" @click="handleDelete">
          删除
        </el-button> -->
      </vab-query-form-right-panel>
    </vab-query-form>

    <el-table ref="tableSort" v-loading="listLoading" :data="list" :element-loading-text="elementLoadingText"
      :height="height" border @selection-change="setSelectRows" @sort-change="tableSortChange">
      <!-- 编码 -->
      <!-- <el-table-column show-overflow-tooltip prop="sort" label="序号" sortable width="150"
        align="center"></el-table-column> -->

      <el-table-column show-overflow-tooltip prop="brand_name" label="品牌名" align="center"></el-table-column>
      <el-table-column show-overflow-tooltip prop="goods_name" label="商品名称" align="center" />
      <el-table-column show-overflow-tooltip prop="en_goods_name" label="商品名称(英文)" align="center" />
      <el-table-column show-overflow-tooltip prop="tax_id" label="商品税号" align="center" />
      <el-table-column show-overflow-tooltip prop="declared_unit_price" label="单价" align="center" />
      <el-table-column show-overflow-tooltip prop="gross_weight" label="总重量" align="center" />
      <el-table-column show-overflow-tooltip prop="tax" label="税金" align="center" />
      <el-table-column show-overflow-tooltip prop="tax_rate" label="税率" align="center" />
      <el-table-column show-overflow-tooltip prop="code" label="海关备案码" align="center" />
      <el-table-column show-overflow-tooltip label="sku" prop="sku" width="340" sortable
        align="center"></el-table-column>
      <el-table-column show-overflow-tooltip label="操作面板" width="250px" align="center">
        <template #default="{ row }">
          <el-button type="text" @click="handleEdit(row)">编辑</el-button>
          <el-button type="text" style="margin-left: 25px; color: #ff0000" @click="handleDelete(row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination :background="background" :current-page="queryForm.page" :layout="layout" :page-size="queryForm.limit"
      :total="total" @current-change="handleCurrentChange" @size-change="handleSizeChange"></el-pagination>
    <manage-brand ref="edit" @fetch-data="getnewlist"></manage-brand>
  </div>
</template>

<script>
  import {
    brandFilingList,
    BrandFilingDel,
    Index_country_list,
    brandFilingExcel_update
  } from '@/api/xgcApi'
  import manageBrand from '../components/registeredProductAdd'
  import exoprt_file from '@/utils/expor_file' // 导出excel文件
  export default {
    name: 'ComprehensiveTable',
    components: {
      manageBrand,
    },
    filters: {
      statusFilter(status) {
        const statusMap = {
          published: 'success',
          draft: 'gray',
          deleted: 'danger',
        }
        return statusMap[status]
      },
    },
    data() {
      return {
        options:[

        ],
        height: '74vh',
        imgShow: true,
        list: [],
        imageList: [],
        listLoading: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
        background: true,
        selectRows: '',
        elementLoadingText: '正在加载...',
        queryForm: {
          page: 1,
          limit: 50,
          keyword: '',
          kor_type:0
        },
        value1: '',
        value: '',
        upFiles: null,
        exportForm3Loading:false
      }
    },
    // computed: {
    //   height() {
    //     return this.$baseTableHeight()
    //   },
    // },
    created() {
      this.fetchData()
      this.getBrand()
    },
    beforeDestroy() {},
    mounted() {},
    methods: {
          beforeupload(files) {
      var file = files.raw
      this.upFiles = file
      this.upFile(this.upFiles)
    },
      // 包裹导入完善
      exportForm3(file) {
        if (
          file.file.type ==
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
          file.file.type == 'application/vnd.ms-excel'
        ) {
          file = file.file
          var data = {
            file: file,
            file_type:1,
            is_admin:1
          }
          this.exportForm3Loading = true
          var url = ''
          exoprt_file('/index/index/file', data)
            .then((res) => {
              var pic = res
              var date = {
                file: pic,
              }
              brandFilingExcel_update(date)
                .then((res) => {
                  this.$baseMessage('操作成功', 'success')
                  this.fetchData()
                  this.exportForm3Loading = false
                })
                .catch((err) => {
                  this.exportForm3Loading = false
                })
            })
            .catch((err) => {
              this.exportForm3Loading = false
            })
          return
        } else {
          this.$baseMessage('请上传正确的文件', 'error')
          this.exportForm3Loading = false
        }
      },
      see_type(e){
         this.$router.push({path: "../manageTypes/index", query: {id: e.id}})
      },
      getBrand(){
        var data = {}
        Index_country_list(data).then(res=>{
          this.options = res.data
        })
      },
      getnewlist() {
        this.fetchData()
      },
      tableSortChange() {
        const imageList = []
        this.$refs.tableSort.tableData.forEach((item, index) => {
          imageList.push(item.img)
        })
        this.imageList = imageList
      },
      setSelectRows(val) {
        this.selectRows = val
      },
      handleAdd() {
        this.$refs['edit'].showEdit()
      },
      handleEdit(row) {
        this.$refs['edit'].showEdit(row)
      },
      handleDelete(row) {
        if (row.id) {
          this.$baseConfirm('你确定要删除当前项吗', null, async () => {
            const {
              msg
            } = await BrandFilingDel({
              ids: row.id
            })
            this.$baseMessage(msg, 'success')
            this.fetchData()
          })
        } else {
          if (this.selectRows.length > 0) {
            const ids = this.selectRows.map((item) => item.id).join()
            this.$baseConfirm('你确定要删除选中项吗', null, async () => {
              const {
                msg
              } = await BrandFilingDel({
                ids: ids
              })
              this.$baseMessage(msg, 'success')
              this.fetchData()
            })
          } else {
            this.$baseMessage('未选中任何行', 'error')
            return false
          }
        }
      },
      handleSizeChange(val) {
        this.queryForm.limit = val
        this.fetchData()
      },
      handleCurrentChange(val) {
        this.queryForm.page = val
        this.fetchData()
      },
      handleQuery() {
        this.queryForm.page = 1
        this.fetchData()
      },
      async fetchData() {
        this.listLoading = true
        const {
          data
        } = await brandFilingList(this.queryForm)
        this.list = data.list
        this.total = data.count
        setTimeout(() => {
          this.listLoading = false
        }, 500)
      },
    },
  }
</script>

<style>
  :deep .right-panel {
    display: flex;
    align-items: center;
  }
</style>
